/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetModifierGroups200ResponseItemsInner
 */
export interface GetModifierGroups200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetModifierGroups200ResponseItemsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetModifierGroups200ResponseItemsInner
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetModifierGroups200ResponseItemsInner
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetModifierGroups200ResponseItemsInner
     */
    allowRepeat: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetModifierGroups200ResponseItemsInner
     */
    max: number;
    /**
     * 
     * @type {number}
     * @memberof GetModifierGroups200ResponseItemsInner
     */
    min: number;
    /**
     * 
     * @type {string}
     * @memberof GetModifierGroups200ResponseItemsInner
     */
    organizationId: string;
    /**
     * 
     * @type {number}
     * @memberof GetModifierGroups200ResponseItemsInner
     */
    position: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetModifierGroups200ResponseItemsInner
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetModifierGroups200ResponseItemsInner
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetModifierGroups200ResponseItemsInner
     */
    externalId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetModifierGroups200ResponseItemsInner
     */
    modifiers: Array<string>;
}

/**
 * Check if a given object implements the GetModifierGroups200ResponseItemsInner interface.
 */
export function instanceOfGetModifierGroups200ResponseItemsInner(value: object): value is GetModifierGroups200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('allowRepeat' in value) || value['allowRepeat'] === undefined) return false;
    if (!('max' in value) || value['max'] === undefined) return false;
    if (!('min' in value) || value['min'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    if (!('modifiers' in value) || value['modifiers'] === undefined) return false;
    return true;
}

export function GetModifierGroups200ResponseItemsInnerFromJSON(json: any): GetModifierGroups200ResponseItemsInner {
    return GetModifierGroups200ResponseItemsInnerFromJSONTyped(json, false);
}

export function GetModifierGroups200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetModifierGroups200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'enabled': json['enabled'],
        'allowRepeat': json['allowRepeat'],
        'max': json['max'],
        'min': json['min'],
        'organizationId': json['organizationId'],
        'position': json['position'],
        'deleted': json['deleted'],
        'source': json['source'] == null ? undefined : json['source'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'modifiers': json['modifiers'],
    };
}

export function GetModifierGroups200ResponseItemsInnerToJSON(json: any): GetModifierGroups200ResponseItemsInner {
    return GetModifierGroups200ResponseItemsInnerToJSONTyped(json, false);
}

export function GetModifierGroups200ResponseItemsInnerToJSONTyped(value?: GetModifierGroups200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'allowRepeat': value['allowRepeat'],
        'max': value['max'],
        'min': value['min'],
        'organizationId': value['organizationId'],
        'position': value['position'],
        'deleted': value['deleted'],
        'source': value['source'],
        'externalId': value['externalId'],
        'modifiers': value['modifiers'],
    };
}

